/** Remember last email used for magic-link sign-in (browser localStorage only; not a credential). */
const STORAGE_KEY = "emailperfect:last_magic_link_email";

export function readLastMagicLinkEmail(): string {
  try {
    if (typeof localStorage === "undefined") {
      return "";
    }
    return localStorage.getItem(STORAGE_KEY)?.trim() ?? "";
  } catch {
    return "";
  }
}

export function writeLastMagicLinkEmail(email: string): void {
  try {
    if (typeof localStorage === "undefined") {
      return;
    }
    const normalized = email.trim().toLowerCase();
    if (!normalized || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)) {
      return;
    }
    localStorage.setItem(STORAGE_KEY, normalized);
  } catch {
    // Private mode, quota, or disabled storage
  }
}
